import { use } from 'echarts/core'
import {
  PieChart
} from 'echarts/charts'
import ECharts, { THEME_KEY } from 'vue-echarts'
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import {
  CanvasRenderer
} from 'echarts/renderers'
import chartjsMixin from '@/agilis/components/Chart/Chartjs/mixin/chartjsMixin'

use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer
])
export default {
  name: 'EchartsPie',
  mixins: [chartjsMixin],
  components: {
    'v-chart': ECharts
  },
  props: {
    items: {
      type: [Object, Array]
    }
  },
  provide: {
    [THEME_KEY]: 'light'
  },
  computed: {
    chartData () {
      if (this.items) {
        let chart = this.dashboardMetric.option
        const columns = Object.values(this.dashboardMetric.detail.dataTable.columns)
        const labelColConfig = columns[0]
        const valueColConfig = columns[1]
        const items = this.items
        chart.series[0].data = []
        items.forEach(item => {
          chart.series[0].data.push(
            {
              value: this.renderColumn(valueColConfig, item),
              name: this.renderColumn(labelColConfig, item)
            }
          )
        })
        return chart
      }
    }
  }
}
